import React from 'react'
import { TopTechLocations } from '../Trends/TopTechLocations'

function TopTechLocation() {
  return (
    <>
        <TopTechLocations />
    </>
  )
}

export default TopTechLocation
